import { combineReducers } from "redux";
import GeneralReducer from "./GeneralReducer";
import AuthReducer from "./AuthReducer";
import ThemeReducer from "./ThemeReducer";
import EventReducer from "./EventReducer";
import PaymentReducer from "./PaymentReducer";
import InspirationalGalleryReducer from "./InspirationalGalleryReducer";
import PhotosReducer from "./PhotosReducer";
import EventPlanningReducer from "./EventPlanningReducer";
import DashboardReducer from "./DashboardReducer";
import VendorReducer from "./VendorReducer";
import AdvertisementReducer from "./AdvertisementReducer";
import PagesReducer from "./PagesReducer";
import PlanningTemplatesReducer from "./PlanningTemplatesReducer";
import ChatReducer from "./ChatReducer";
import ReviewReducer from "./ReviewReducer";
import NotificationReducer from "./NotificationReducer";
import GuestReducer from "./GuestReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import PlaylistReducer from "./PlaylistReducer";

const eventPlanPersistConfig = {
  key: "root",
  storage: storage,
  whitelist: [
    "EventPlanningReducer",
    "GuestReducer",
    "EventReducer",
    "AuthReducer",
  ],
};

const AppReducers = combineReducers({
  GeneralReducer,
  AuthReducer,
  ThemeReducer,
  EventReducer,
  PaymentReducer,
  InspirationalGalleryReducer,
  PhotosReducer,
  EventPlanningReducer,
  DashboardReducer,
  VendorReducer,
  AdvertisementReducer,
  PagesReducer,
  PlanningTemplatesReducer,
  ChatReducer,
  ReviewReducer,
  NotificationReducer,
  GuestReducer,
  PlaylistReducer
});

const Reducer = (state, action) => {
  if (action.type === "IsLogout") {
    return AppReducers(undefined, action);
  }
  return AppReducers(state, action);
};
const persistedReducer = persistReducer(eventPlanPersistConfig, Reducer);

export default persistedReducer;
